import { render, staticRenderFns } from "./IconSvgForward.vue?vue&type=template&id=4d539d1c&scoped=true&"
import script from "./IconSvgForward.vue?vue&type=script&lang=js&"
export * from "./IconSvgForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d539d1c",
  null
  
)

export default component.exports